import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock, Shield, Gift, CheckCircle2, MessageCircle } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'CHECKLIST FBI/APOSTILLA: Documentos Críticos',
  subtitle: '¿Qué papeles necesitas sacar antes de salir?',
  image: 'https://cdn.magicpatterns.com/uploads/uhLWM1JGhFCwioEgwKr8mA/1.png',
  value: '$47',
  icon: AlertTriangle,
  description: 'La lista exacta de documentos que debes tramitar en EE.UU. antes de irte. Si te falta uno, tu residencia en otro país puede ser denegada.',
  bullets: ['Cómo obtener tu récord del FBI sin alertar a ICE.', 'El proceso de Apostilla de La Haya paso a paso.', 'Documentos escolares para tus hijos nacidos en USA.', 'Tiempos exactos de trámite para que no caduquen.'],
  testimonial: {
    text: 'Casi me voy sin apostillar mi acta de matrimonio. Esta lista me salvó de tener que regresar a USA.',
    author: 'Roberto G., Ex-Texas'
  }
}, {
  id: 2,
  title: 'GUÍA BANCARIA ANTI-BLOQUEO: Protege tus Ahorros',
  subtitle: 'No dejes que el banco congele tu dinero al salir.',
  image: 'https://cdn.magicpatterns.com/uploads/wiWCXRqeJFZwywy4CCeeHF/2.png',
  value: '$47',
  icon: Clock,
  description: 'Cómo mover tus dólares legalmente sin que Chase, Bank of America o Wells Fargo bloqueen tu cuenta por "actividad sospechosa internacional".',
  bullets: ['La llamada exacta que debes hacer al banco antes de tu vuelo.', 'Límites de transferencias internacionales (SWIFT) sin red flags.', 'Cómo abrir cuentas en tu país destino desde EE.UU.', 'Alternativas legales si no tienes cuenta bancaria formal.', 'Declaración de efectivo en aduanas (la regla de los $10k).'],
  testimonial: {
    text: 'Pude transferir mis $15,000 a España sin un solo problema. El banco ni siquiera hizo preguntas.',
    author: 'Elena M., Ex-Florida'
  }
}, {
  id: 3,
  title: 'MATRIZ DE COSTOS + PLAN 90 DÍAS: Tu Mapa Financiero',
  subtitle: 'Elige tu destino basado en tu presupuesto exacto.',
  image: 'https://cdn.magicpatterns.com/uploads/6msJJKZkXy3iUxeCqMGhQC/3.png',
  value: '$47',
  icon: Shield,
  description: 'Una hoja de ruta financiera para saber exactamente a qué país puedes aplicar con tus ahorros actuales, sin sorpresas ocultas.',
  bullets: ['Desglose de costos de visa, abogados locales y vuelos.', 'Costo de vida mensual en los 5 Países de Oro.', 'Requisitos de solvencia económica (cuánto debes demostrar).', 'Cronograma de 90 días desde la decisión hasta la cédula.'],
  testimonial: {
    text: 'Con mis $6,000 pensé que no me alcanzaba para nada. La matriz me mostró que Paraguay era perfecto para mí.',
    author: 'Luis P., Ex-California'
  }
}];
export function BonusSection() {
  return <section className="py-8 md:py-16 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-48">
      <div className="max-w-[800px] mx-auto" data-id="element-49">
        {/* Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-50">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-[var(--accent-soft)] text-[var(--accent)] mb-3 md:mb-6" data-id="element-51">
            <Gift className="w-6 h-6 md:w-8 md:h-8" data-id="element-52" />
          </div>
          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-2 md:mb-4" data-id="element-53">
            Incluye 3 bonos estratégicos
          </h2>
          <p className="text-sm md:text-lg text-[var(--text-primary)] leading-relaxed font-light max-w-2xl mx-auto" data-id="element-54">
            3 recursos críticos para asegurar que tu salida sea 100% legal y sin
            pérdida de dinero.
          </p>
        </motion.div>

        {/* The Truth — simplified */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-[var(--bg-deep)] border border-[var(--border-subtle)] rounded-xl p-4 md:p-6 mb-6 md:mb-12 shadow-lg relative overflow-hidden" data-id="element-55">
          <div className="absolute top-0 left-0 w-1 h-full bg-[var(--accent)]" data-id="element-56"></div>
          <p className="text-[var(--text-primary)] font-medium text-sm md:text-base mb-2" data-id="element-57">
            ¿Qué haces antes de comprar tu boleto de avión?
          </p>
          <ul className="space-y-1.5 text-[var(--text-muted)] text-xs md:text-sm mb-3" data-id="element-58">
            <li className="flex items-start gap-2" data-id="element-59">
              <span className="text-base leading-none" data-id="element-60">😰</span> Tienes miedo de
              que te bloqueen tu cuenta bancaria?
            </li>
            <li className="flex items-start gap-2" data-id="element-61">
              <span className="text-base leading-none" data-id="element-62">😓</span> No sabes qué
              documentos tramitar en EE.UU.?
            </li>
            <li className="flex items-start gap-2" data-id="element-63">
              <span className="text-base leading-none" data-id="element-64">💔</span> Temes que tus
              ahorros no sean suficientes?
            </li>
          </ul>
          <p className="text-[var(--accent)] font-bold text-sm" data-id="element-65">
            Para eso están estos 3 bonos.
          </p>
        </motion.div>

        {/* The Bonuses — compact for mobile */}
        <div className="space-y-6 md:space-y-12" data-id="element-66">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[var(--bg-card)] rounded-xl md:rounded-2xl border border-[var(--accent)]/20 overflow-hidden shadow-xl" data-id="element-67">
              <div className="grid md:grid-cols-2 gap-0" data-id="element-68">
                <div className="relative h-40 md:h-auto bg-[var(--bg-deep)] p-4 md:p-6 flex items-center justify-center border-b md:border-b-0 md:border-r border-[var(--border-subtle)]" data-id="element-69">
                  <div className="absolute top-3 left-3 bg-[var(--accent)] text-[var(--bg-deep)] text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider z-10" data-id="element-70">
                    Bono #{bonus.id}
                  </div>
                  <img src={bonus.image} alt={bonus.title} className="w-full max-w-[180px] md:max-w-[280px] h-auto object-contain drop-shadow-2xl rounded-lg" data-id="element-71" />
                </div>
                <div className="p-4 md:p-8 flex flex-col justify-center" data-id="element-72">
                  <div className="flex items-center gap-2 text-[var(--accent)] mb-2" data-id="element-73">
                    <bonus.icon className="w-4 h-4" data-id="element-74" />
                    <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-75">
                      Incluido gratis
                    </span>
                  </div>
                  <h3 className="text-base md:text-2xl font-serif font-bold text-[var(--text-heading)] mb-1.5 leading-tight" data-id="element-76">
                    {bonus.title}
                  </h3>
                  <p className="text-[var(--accent)] font-serif italic text-sm md:text-lg mb-2 md:mb-4" data-id="element-77">
                    "{bonus.subtitle}"
                  </p>
                  <p className="text-[var(--text-muted)] text-xs md:text-sm mb-3 md:mb-6 leading-relaxed" data-id="element-78">
                    {bonus.description}
                  </p>
                  <ul className="space-y-1.5 md:space-y-3 mb-3 md:mb-6" data-id="element-79">
                    {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-1.5 text-xs md:text-sm text-[var(--text-primary)]" data-id="element-80">
                        <CheckCircle2 className="w-3.5 h-3.5 text-[var(--accent)] flex-shrink-0 mt-0.5" data-id="element-81" />
                        <span className="leading-snug" data-id="element-82">{bullet}</span>
                      </li>)}
                  </ul>

                  {/* Testimonial */}
                  <div className="bg-[var(--bg-elevated)] p-3 md:p-4 rounded-lg border border-[var(--border-subtle)] mt-auto" data-id="element-83">
                    <div className="flex items-start gap-2" data-id="element-84">
                      <MessageCircle className="w-4 h-4 text-[var(--accent)] opacity-50 flex-shrink-0 mt-0.5" data-id="element-85" />
                      <div data-id="element-86">
                        <p className="text-[var(--text-primary)] text-xs italic mb-1" data-id="element-87">
                          "{bonus.testimonial.text}"
                        </p>
                        <p className="text-[var(--text-muted)] text-[10px] font-bold uppercase tracking-wider" data-id="element-88">
                          — {bonus.testimonial.author}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}